var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnorderedListBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9C2.44772 9 2 9.44772 2 10C2 10.5523 2.44772 11 3 11V9ZM18.7735 10L13 4.2265L7.2265 10L13 15.7735L18.7735 10ZM3 11H13V9H3V11Z",
    fill: "#FFAC2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnorderedListBullet);
export default __webpack_public_path__ + "static/media/UnorderedListBullet.f2992e057f32abdf2fdac4d1a84f1603.svg";
export { ForwardRef as ReactComponent };